export default __webpack_public_path__ + "static/media/mb-logo.d7649419.png";